module.exports = __webpack_public_path__ + "img/facebook.924b6504.png";